import React from 'react';

import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';

import ErrorScreen from 'components/shared/ErrorScreen';
import { MetaNoIndex } from 'components/shared/MetaNoIndex';
import { useGTM } from 'hooks/useGTM';
import { usePendingFilesDownloading } from 'hooks/usePendingFilesDownloading';
import { itineraryAccountGtmContainerSelector } from 'store/itinerariesItem/selectors';

import useFontAwesome from '../../../integrations/fontawesome/useFontAwesome';
import Itinerary from './Itinerary';

function ClientPortal({ external = false }) {
  usePendingFilesDownloading();
  useFontAwesome();

  const gtmContainerId = useSelector(itineraryAccountGtmContainerSelector);
  useGTM(gtmContainerId);

  return (
    <>
      <MetaNoIndex />

      <Switch>
        <Route path={'/:handle/:id(\\d+)'} component={Itinerary} />
        {external && <Route path={'/:tail'} component={Itinerary} />}
        <Route component={() => <ErrorScreen status="404" />} />
      </Switch>
    </>
  );
}

export default ClientPortal;
